const Grow = r => require.ensure([], () => r(require('@/views/grow/grow')), '@/views/grow/..')
const Value = r => require.ensure([], () => r(require('@/views/grow/value')), '@/views/grow/..')

export default [
    {
        path: '',
        component: Grow,
        meta: {
            title: '我的成长值'
        }
    },
    {
        path: 'value',
        component: Value,
        redirect: to => {
            const { params } = to
            if (params.module === 'student') {
                return '/task/help/growth/NEW_USER'
            } else {
                return '/teacher/grow/oldValue'
            }
        },
        meta: {
            title: '如何获取成长值'
        }
    },
    {
        path: 'oldValue',
        component: Value,
        meta: {
            title: '如何获取成长值'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/grow.js